import { kn } from "../../../../date-fns/locale/kn.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    kn
  }
};